var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavHideIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nav-hide-icon",
    "data-name": "nav-hide-icon",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(31 32) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,2,6.6,3.4,11.2,8,6.6,12.6,8,14l6-6ZM0,16H2V0H0Z",
    fill: "#555"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavHideIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-hide-icon.49993b7c107dd60841103b70dfa2f489.svg";